import { render, staticRenderFns } from "./TrialEndClock.vue?vue&type=template&id=22a152aa&scoped=true&"
import script from "./TrialEndClock.vue?vue&type=script&lang=js&"
export * from "./TrialEndClock.vue?vue&type=script&lang=js&"
import style0 from "./TrialEndClock.vue?vue&type=style&index=0&id=22a152aa&prod&scoped=true&lang=scss&"
import style1 from "./TrialEndClock.vue?vue&type=style&index=1&id=22a152aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a152aa",
  null
  
)

export default component.exports